import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import InnerPageLayout from "../Layout/InnerPageLayout";
import FlipBookControlDemo from "./FlipBookControlDemo";

const HRPolicy = () => {
  // const [loading, setLoading] = useState(false);
  // const { i18n, t } = useTranslation();

  return (
    <InnerPageLayout>
      <FlipBookControlDemo />
    </InnerPageLayout>
  );
};
export default HRPolicy;
